import type {
    CardDefinitionEntityObject,
    CardDefinitionQueryParams,
} from "src/app/features/CardImplementation/subFeatures/CardDefinition/services/server/CardDefinitionQueryTypes";
import { getAssignedDataGroup } from "../../../../../../../core/router/auth";
import { ResourceName } from "../../../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../../../core/service/baseApi";
import type { Dto } from "../../../../../../../core/types/be/Dto";
import type { CardDefinitionEntity } from "../../types/CardDefinitionEntity";
import { CardDefinitionDtoToEntity } from "../mappers/CardDefinitionDtoToEntity";
import { CardDefinitionEntityToDto } from "../mappers/CardDefinitionEntityToDto";

const CardDefinitionApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        CardDefinitionLoad: builder.query<CardDefinitionEntity, CardDefinitionQueryParams>({
            providesTags: [ResourceName.CARD_DEFINITIONS],
            query: (cardDefinitionQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardDefinitionQueryParams.cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${cardDefinitionQueryParams.id}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return CardDefinitionDtoToEntity(response);
            },
        }),
        CardDefinitionSave: builder.mutation<CardDefinitionEntity, CardDefinitionEntityObject>({
            query: ({ cardDefinitionFormData, cardDefinitionQuery }) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardDefinitionQuery.cardImplementationId}/${ResourceName.CARD_DEFINITIONS}`;
                const method = "POST";

                const body = CardDefinitionEntityToDto(cardDefinitionFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_DEFINITIONS],
        }),
        CardDefinitionUpdate: builder.mutation<CardDefinitionEntity, CardDefinitionEntityObject>({
            query: ({ cardDefinitionFormData, cardDefinitionQuery }) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardDefinitionQuery.cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${cardDefinitionQuery.id}`;
                const method = "PUT";

                const body = CardDefinitionEntityToDto(cardDefinitionFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_DEFINITIONS],
        }),
        CardDefinitionDelete: builder.mutation<CardDefinitionEntity, CardDefinitionQueryParams>({
            query: (cardDefinitionQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardDefinitionQueryParams.cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${cardDefinitionQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.CARD_DEFINITIONS],
        }),
    }),
});

export const {
    useCardDefinitionLoadQuery,
    useCardDefinitionSaveMutation,
    useCardDefinitionUpdateMutation,
    useCardDefinitionDeleteMutation,
} = CardDefinitionApi;
